import { startCase, toLower } from 'lodash';

export const FILTER_KEYS = {
  ACCOUNT_STATUS: 'account_status',
  RENEWAL_STATUS: 'renewal_status',
  PAYMENT_CONFIRMATION: 'payment_confirmation',
};

export const initialFilterValues = {
  [FILTER_KEYS.ACCOUNT_STATUS]: '',
  [FILTER_KEYS.RENEWAL_STATUS]: '',
  [FILTER_KEYS.PAYMENT_CONFIRMATION]: '',
};

export const ACCOUNT_STATUSES = {
  ACTIVE: 'ACTIVE',
  CANCELLED: 'CANCELLED',
  NON_RENEWING: 'NON_RENEWING',
  CONFIRMED: 'CONFIRMED',
  OVERDUE: 'OVERDUE',
  SUSPENDED: 'SUSPENDED',
  PENDING_RENEWAL: 'PENDING_RENEWAL',
};

export const accountStatusOptions = [
  {
    name: startCase(toLower(ACCOUNT_STATUSES.ACTIVE)),
    value: ACCOUNT_STATUSES.ACTIVE,
  },
  {
    name: startCase(toLower(ACCOUNT_STATUSES.CONFIRMED)),
    value: ACCOUNT_STATUSES.CONFIRMED,
  },
  {
    name: startCase(toLower(ACCOUNT_STATUSES.OVERDUE)),
    value: ACCOUNT_STATUSES.OVERDUE,
  },
  {
    name: startCase(toLower(ACCOUNT_STATUSES.SUSPENDED)),
    value: ACCOUNT_STATUSES.SUSPENDED,
  },
  {
    name: startCase(toLower(ACCOUNT_STATUSES.PENDING_RENEWAL)),
    value: ACCOUNT_STATUSES.PENDING_RENEWAL,
  },
  {
    name: startCase(toLower(ACCOUNT_STATUSES.NON_RENEWING)),
    value: ACCOUNT_STATUSES.NON_RENEWING,
  },
  {
    name: startCase(toLower(ACCOUNT_STATUSES.CANCELLED)),
    value: ACCOUNT_STATUSES.CANCELLED,
  },
];

export const RENEWAL_STATUSES = {
  CONFIRM_RENEWAL: 'CONFIRM_RENEWAL',
  CANCEL_SUBSCRIPTION: 'CANCEL_SUBSCRIPTION',
  NO_ACTION: 'NO_ACTION',
};

export const renewalStatusOptions = [
  {
    name: startCase(toLower(RENEWAL_STATUSES.CONFIRM_RENEWAL)),
    value: '1',
  },
  {
    name: startCase(toLower(RENEWAL_STATUSES.CANCEL_SUBSCRIPTION)),
    value: '0',
  },
  {
    name: startCase(toLower(RENEWAL_STATUSES.NO_ACTION)),
    value: RENEWAL_STATUSES.NO_ACTION,
  },
];

export const PAYMENT_CONFIRMATION = {
  CONFIRMED: 'CONFIRMED',
  NO_ACTION: 'NO_ACTION',
};

export const paymentConfirmationOptions = [
  {
    name: startCase(toLower(PAYMENT_CONFIRMATION.CONFIRMED)),
    value: '1',
  },
  {
    name: startCase(toLower(RENEWAL_STATUSES.NO_ACTION)),
    value: '0',
  },
];

export const headerCells = [
  { title: 'Customer', sortable: true, sortValue: 'customerName' },
  { title: 'Account', sortable: true, sortValue: 'fullDomain' },
  { title: 'Account status', sortable: true, sortValue: 'accountStatus' },
  { title: 'Subscription', sortable: true, sortValue: 'subscriptionPlan' },
  { title: 'Subscription status', sortable: true, sortValue: 'subscriptionStatus' },
  { title: 'Renewal date', sortable: true, sortValue: 'renewalDate' },
  { title: 'Renewal status', sortable: true, sortValue: 'renewalStatus' },
  { title: 'Payment confirmation', sortable: true, sortValue: 'paymentConfirmation' },
  { title: 'Latest login', sortable: true, sortValue: 'lastLogin' },
  { title: '' },
];

export const initialfilterMapArray = [
  {
    title: 'Account Status',
    options: [
      { id: 1, field: 'ACTIVE', label: 'Active', selected: false },
      { id: 2, field: 'OVERDUE', label: 'Overdue', selected: false },
      { id: 3, field: 'NON_RENEWING', label: 'Non Renewal', selected: false },
      { id: 4, field: 'SUSPENDED', label: 'Suspended', selected: false },
      { id: 5, field: 'CANCELLED', label: 'Cancelled', selected: false },
    ],
  },
  {
    title: 'Renewal Status',
    options: [
      { id: 6, field: 'CONFIRM_RENEWAL', label: 'Confirm Renewal', selected: false },
      { id: 7, field: 'CANCEL_SUBSCRIPTION', label: 'Cancel subscription', selected: false },
      { id: 8, field: 'NO_ACTION', label: 'No Action', selected: false },
    ],
  },
  {
    title: 'Payment Confirmation',
    options: [
      { id: 9, field: 'CONFIRMED', label: 'Confirmed', selected: false },
      { id: 10, field: 'NO_ACTION', label: 'No Action', selected: false },
    ],
  },
  {
    title: 'Subscription Status',
    options: [
      { id: 11, field: 'ACTIVE', label: 'Active', selected: false },
      { id: 12, field: 'NON_RENEWING', label: 'Non Renewal', selected: false },
      { id: 13, field: 'CANCELLED', label: 'Cancelled', selected: false },
    ],
  },
];
